<template>
  <div class="mall-media-info">
    <div class="mall-media-info-hd">
      <img :src="pic | replaceUrlProtocol" v-if="pic">
    </div>
    <div class="mall-media-info-bd">
      <h3>{{ title }}</h3>
      <p>{{ desc }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MallMediaInfo',

  props: {
    pic: {
      type: String,
      default: ''
    },

    title: {
      type: String,
      default: ''
    },

    desc: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="scss">
.mall-media-info {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: flex-start;
  align-items: flex-start;
  justify-content: flex-start;

  .mall-media-info-hd {
    flex-shrink: 0;
    width: 50px;
    height: 50px;
    margin-right: 8px;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 4px;
    }
  }

  .mall-media-info-bd {
    flex: 1 1 auto;

    h3 {
      color: #121212;
      font-weight: bold;
      font-size: 14px;
    }

    p {
      margin-top: 6px;
      color: #aaa;
      font-size: 10px;
      line-height: 1.5;
    }
  }
}
</style>
